<script>
  import Text from "$lib/Text.svelte";
  import Icon from "$lib/Icon.svelte";

  export let block;
  let active = 0;

  const mod = (n, m) => {
    return ((n % m) + m) % m;
  };

  const next = (prev = false) => {
    active = mod(active + (prev ? -1 : 1), block.fields.length);
  };
</script>

<div class="w-screen overflow-hidden relative dark">
  <div
    class="flex transition duration-300 transform"
    style="width: {block.fields.length * 100}%; transform: translateX({-(
      100 * active
    ) / block.fields.length}%)"
  >
    {#each block.fields as { text, headline }}
      <div class="w-screen flex-shrink-0 p-16 lg:p-24">
        <div class="max-w-content mx-auto text-center">
          <h2 class="text-4xl lg:text-9xl uppercase font-extrabold mb-4">
            {headline}
          </h2>
          <Text {text} class="mt-auto text-2xl font-display" />
        </div>
      </div>
    {/each}
  </div>
  <button
    class="absolute inset-y-0 right-0 my-auto text-3xl lg:text-6xl focus:outline-none"
    on:click={() => next(false)}><Icon icon="chevron-right" /></button
  >
  <button
    class="absolute inset-y-0 left-0 my-auto text-3xl lg:text-6xl focus:outline-none"
    on:click={() => next(true)}><Icon icon="chevron-left" /></button
  >
</div>
